import React, { useState } from 'react';
import { useAsync } from 'react-use';
import { useDispatch, useSelector } from 'react-redux';

import selectors from 'state/selectors';
import services from 'services';
import actions from 'state/actions';
import utils from 'utils';

import Header from '../../components/Header';
import Mail from './Mail';
import Disk from './Disk';

export interface RangeDate {
  from: Date | null;
  to: Date | null;
}

const Dashboard = () => {
  const dispatch = useDispatch();
  const [date, setDate] = useState<Date>(new Date());
  const [rangeDateActive, setRangeDateActive] = useState<boolean>(false);
  const [rangeDate, setRangeDate] = useState<RangeDate>({ from: null, to: null });
  const tab = useSelector(selectors.normalizer.getTab);

  useAsync(async () => {
    if (rangeDateActive && !(rangeDate.from || rangeDate.to)) return;

    let dateFrom;
    let dateTo;

    if (rangeDateActive) {
      dateFrom = rangeDate.from ? utils.date.formatDateForDb(rangeDate.from) : '01-01-1970';
      dateTo = utils.date.formatDateForDb(rangeDate.to ? rangeDate.to : new Date());
    } else {
      dateFrom = utils.date.formatDateForDb(date);
      dateTo = utils.date.formatDateForDb(date);
    }

    try {
      const { data } = await services.checkDiskCount(dateFrom, dateTo);
      dispatch(actions.normalizer.setDashboardDiskCount(data));
    } catch (e) {
      console.error(e);
    }
  }, [date, rangeDate, rangeDateActive]);

  useAsync(async () => {
    try {
      const { data } = await services.checkDiskStatus();
      dispatch(actions.normalizer.setDashboardDiskStatus(data));
    } catch (e) {
      console.error(e);
    }
  }, []);

  return (
    <>
      <Header
        date={date}
        setDate={setDate}
        rangeDateActive={rangeDateActive}
        setRangeDateActive={setRangeDateActive}
        rangeDate={rangeDate}
        setRangeDate={setRangeDate}
      />
      {tab === 'mail' ? <Mail date={date} rangeDate={rangeDate} rangeDateActive={rangeDateActive} /> : <Disk />}
    </>
  );
};

export default Dashboard;
